<template lang="pug">
.tutor#members
  .index-list-tutor
    ul.index-list
      .index-list-title
        h1 加入他们
        h1.two 成为他们
      li(v-for="(name, $index) in tutor.items")
        img(:src="['/static/img/'+members[name].pic]", :alt="members[name].name")
        .tutor-info
          img.sup(v-show="members[name].sponsor", src='../assets/imgs/sup.png')
          h3 {{members[name].name}}
          h4 {{members[name].company}}
          p {{members[name].position}}
</template>

<script>
export default {
  name: 'vcontent',
  computed: {
    members() {
      return this.$store.state.config['members']
    },
    tutor() {
      return this.$store.state.config['tutor']
    }
  }
}
</script>

<style lang="stylus">
@import '../assets/css/var'

.tutor
  text-align center
  .index-list-tutor
    padding-top 80px
    background #F2F2F2
    .index-list-title
      width 28%
      display inline-block
      vertical-align middle
      h1
        text-align center
        font-size 64px
        font-family 'FZLTTHCJW--GB1-0'
        letter-spacing 5px
        line-height 1.2em
        color #000
        &.two
          text-indent 1em
    li
      position relative
      display inline-block
      vertical-align middle
      width 13%
      &:nth-child(14n+13)
        margin-right 8%
      img
        width 100%
        vertical-align middle
      .tutor-info
        position absolute
        bottom -7px
        left 8%
        right 8%
        z-index 2
        padding 5px 6px
        background #fff
        overflow hidden
        h3
          font-size 18px
          font-family 'Noto Sans SC', sans-serif
          font-weight 900
          line-height 18px
        h4
          font-size 12px
          font-family 'Noto Sans SC', sans-serif
          font-weight 400
          padding 0.4em 0 0.2em
        p
          font-family 'Noto Sans SC', sans-serif
          font-weight 300
          font-size 12px
        .star
          position absolute
          top 50%
          left 0
          width 1em
          padding 0.3em 0.2em
          text-align center
          background #5FC4FF
          color #fff
          font-size 10px
          transform translate(0, -50%)
        .sup
          position absolute
          top 50%
          left 0
          height 90%
          width auto
          transform translate(0, -50%)

</style>



// WEBPACK FOOTER //
// Tutor.vue?697ad314